import React from 'react';
import styled from 'styled-components';

const DiagnosisEndTemplate = () => {
    return(
        <Wrap>
            <div className="logo_box">
                <figure>
                    <img src={require("../style/img/end-heart.svg")} alt="하트"/>
                </figure>
                <figure>
                    <img src={require("../style/img/fordate-text.svg")} alt="하트"/>
                </figure>
            </div>

            <div className="guide_box">
                <p>진단지 제출이</p>
                <p className="highlight">완료되었습니다.</p>
            </div>

            <div className="shortcuts">
                <p>카카오톡@포데이트로</p>
                <p>성함+휴대폰 뒷번호를 보내주세요.</p>

                <button onClick={() => window.location.href = "http://pf.kakao.com/_Fbcxfd/chat"}>

                    <span>카카오톡@포데이트</span>바로가기
                </button>
            </div>
        </Wrap>
    );
};

const Wrap = styled.div`
    width: 375px;
    margin: 0 auto;
    overflow: hidden;
    text-align: center;

    .logo_box {
        margin-top:134.4px;
        figure {
            text-align: center;

            & + figure {
                margin-top: 9px;
            }
        }
    }

    .guide_box {
        margin-top: 46.3px;

        p {
            color: #3e3e3e;
            font-size: 40px;
            line-height: 45px;

            &.highlight{
                font-weight: bold;
            }
        }
    }

    .shortcuts {
        margin-top: 66px;
        
        p {
            font-size: 14px;
            color: #808080;
            line-height: 16px;
        }

        button {
            width: 300px;
            height: 40px;
            margin: 19px 0 0;
            padding: 12px 67px 12px 63px;
            border-radius: 10px;
            border: solid 1px #aaaaaa;
            background-color: #ffffff;
            color: #b2b2b2;
            font-size: 14px;

            span {
                color: #ff6e75;
            }
        }
    }
`;

export default DiagnosisEndTemplate;